import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const DEFAULT_VIEWPORT = { once: true, margin: "-80px" };
const REVEAL_ANIMATE = { opacity: 1, y: 0 };
const REVEAL_ITEM_VARIANTS = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } },
};

export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={REVEAL_ANIMATE}
      viewport={once ? DEFAULT_VIEWPORT : { once, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const RevealStagger = ({ children, className = "", staggerDelay = 0.08 }) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={DEFAULT_VIEWPORT}
      transition={{ staggerChildren: staggerDelay }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const RevealItem = ({ children, className = "" }) => (
  <motion.div variants={REVEAL_ITEM_VARIANTS} className={className}>
    {children}
  </motion.div>
);
